// Given a string, will attempt to convert it to a primitive type
/**
 * Returns a primitive type or original value
 * @param {any} value
 */
const convert = value => {
  if (typeof value != 'string') return value

  // Number test
  if (/^[\d\.]+$/.test(value)) return parseFloat(value); // eslint-disable-line no-useless-escape

  // Boolean test (case insensitive)
  if (/^(true|false)$/i.test(value)) return JSON.parse(value.toLowerCase())

  // Array / Json test
  if (/^\[.+\]$|^\{.+\}$/.test(value)) return JSON.parse(value)

  return value
}

const StringToPrimitive = { convert }
export default StringToPrimitive



// WEBPACK FOOTER //
// ./js/utils/StringToPrimitive.js